import { Plus, X } from "lucide-react";

export const OPERANDS = [
  { v: "CLOSE", l: "Close" }, { v: "OPEN", l: "Open" }, { v: "HIGH", l: "High" }, { v: "LOW", l: "Low" }, { v: "VOLUME", l: "Volume" },
  { v: "EMA", l: "EMA", p: 9 }, { v: "SMA", l: "SMA", p: 50 }, { v: "RSI", l: "RSI", p: 14 },
  { v: "MACD", l: "MACD Line" }, { v: "MACD_SIGNAL", l: "MACD Signal" }, { v: "MACD_HIST", l: "MACD Hist" },
  { v: "BB_UPPER", l: "BB Upper", p: 20 }, { v: "BB_MIDDLE", l: "BB Middle", p: 20 }, { v: "BB_LOWER", l: "BB Lower", p: 20 },
  { v: "VALUE", l: "Number" },
];
const OPS = [
  { v: "crosses_above", l: "crosses above" }, { v: "crosses_below", l: "crosses below" },
  { v: ">", l: "is greater than" }, { v: "<", l: "is less than" },
];
const meta = (t) => OPERANDS.find((o) => o.v === t) || {};

const Operand = ({ value, onChange, tid }) => {
  const m = meta(value.type);
  return (
    <div className="flex gap-1">
      <select data-testid={`${tid}-type`} className="field" value={value.type}
        onChange={(e) => onChange({ type: e.target.value, period: meta(e.target.value).p ?? null, value: e.target.value === "VALUE" ? 50 : null })}>
        {OPERANDS.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
      {m.p != null && (
        <input data-testid={`${tid}-period`} type="number" min={1} className="field w-14" value={value.period ?? m.p}
          onChange={(e) => onChange({ ...value, period: Number(e.target.value) })} />
      )}
      {value.type === "VALUE" && (
        <input data-testid={`${tid}-value`} type="number" className="field w-20" value={value.value ?? 0}
          onChange={(e) => onChange({ ...value, value: Number(e.target.value) })} />
      )}
    </div>
  );
};

export const RuleBlock = ({ title, block, onChange, prefix, accent }) => {
  const setCond = (i, c) => onChange({ ...block, conditions: block.conditions.map((x, j) => (j === i ? c : x)) });
  const add = () => onChange({ ...block, conditions: [...block.conditions, { left: { type: "RSI", period: 14 }, op: ">", right: { type: "VALUE", value: 50 } }] });
  return (
    <div className="panel" data-testid={`${prefix}-block`}>
      <div className="flex items-center gap-3 px-3 py-2 border-b border-[#163056]">
        <span className="w-1 h-4" style={{ background: accent }} />
        <span className="font-display text-sm font-semibold text-slate-100">{title}</span>
        <div className="flex ml-auto border border-[#163056] rounded-sm overflow-hidden">
          {["AND", "OR"].map((l) => (
            <button key={l} data-testid={`${prefix}-logic-${l.toLowerCase()}`} onClick={() => onChange({ ...block, logic: l })}
              className={`px-2 h-6 text-[10px] font-mono transition-colors ${block.logic === l ? "bg-[#22A34A] text-[#071525]" : "text-slate-400 hover:text-white"}`}>
              {l}
            </button>
          ))}
        </div>
      </div>
      <div className="p-3 space-y-2">
        {block.conditions.map((c, i) => (
          <div key={i} className="flex flex-wrap items-center gap-2 rise" data-testid={`${prefix}-condition-${i}`}>
            <span className="font-mono text-[10px] text-slate-500 w-8">{i === 0 ? "IF" : block.logic}</span>
            <Operand tid={`${prefix}-cond-${i}-left`} value={c.left} onChange={(v) => setCond(i, { ...c, left: v })} />
            <select data-testid={`${prefix}-cond-${i}-op`} className="field text-[#22A34A]" value={c.op} onChange={(e) => setCond(i, { ...c, op: e.target.value })}>
              {OPS.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
            </select>
            <Operand tid={`${prefix}-cond-${i}-right`} value={c.right} onChange={(v) => setCond(i, { ...c, right: v })} />
            <button data-testid={`${prefix}-cond-${i}-remove`} onClick={() => onChange({ ...block, conditions: block.conditions.filter((_, j) => j !== i) })}
              className="ml-auto text-slate-500 hover:text-[#FF3B30] transition-colors"><X className="w-4 h-4" /></button>
          </div>
        ))}
        {!block.conditions.length && <div className="text-xs text-slate-500">No conditions — add one below.</div>}
        <button data-testid={`${prefix}-add-condition`} onClick={add} className="btn-ghost h-7 mt-1"><Plus className="w-3.5 h-3.5" /> Add condition</button>
      </div>
    </div>
  );
};
